// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const BUILDINFO = {
  "hash": "7296a627025e17065a67be70a15108b4d4ea0a87",
  "tag": "",
  "github": {
    "runId": "",
    "runNumber": "",
    "runAttempt": ""
  }
};
/* tslint:enable */
